export const MENU_CLOSE_ANIMATION_DURATION = 500 + 350; // animation + delay

export const MENU_ITEM_ANIMATION_DURATION = 95;
